import { FaqItems } from "./types";
import { CarouselData } from "./types";
import routes from "@/constants/routes";

export const faqItems: FaqItems = [
  {
    index: 0,
    category: "Learn about Klink",
    question: "What is Klink?",
    answer:
      "Klink helps future and existing home owners build a home ownership plan. At first, you set your home ownership goals to see how long it will take to get there and what might be holding you back.",
  },
  {
    index: 1,
    category: "Learn about Klink",
    question: "How does Klink work?",
    answer:
      "After linking your accounts, Klink generates insights to help you understand your spending, where you have opportunities to save more, and what may be damaging your chances of buying the home you want. Whether you are a first time buyer or looking to buy your next home, Klink helps you get there sooner.",
  },
  {
    index: 2,
    category: "Learn about Klink",
    question: "How can I learn more about Klink?",
    answer:
      "Sign up to receive updates about Klink <b><a class='text-magenta' href='https://www.klink-app.com/#signup'>here</a></b>. You can also follow us on <b><a class='text-magenta' href='https://www.instagram.com/klink__app/' target='_blank'>Instagram</a></b>, <b><a class='text-magenta' href='https://www.tiktok.com/@klink_app' target='_blank'>TikTok</a></b> and <b><a class='text-magenta' href='https://twitter.com/klink_app' target='_blank'>X (Twitter)</a></b> for news and updates.",
  },
  {
    index: 3,
    category: "Learn about Klink",
    question: "Why does Klink exist? Who are you?",
    answer:
      "We are a team of passionate engineers, designers, product and finance people who care deeply about helping more people achieve their dream of home ownership.<br/><br/>We are the same team who built <b><a class='text-magenta' href='https://www.keyzy.com/?ref=klink' target='_blank'>Keyzy</a></b>, the rent-to-own solution for aspiring home buyers without a deposit to qualify for a mortgage. ",
  },
  {
    index: 4,
    category: "Learn about Klink",
    question: "Is the Klink app free?",
    answer:
      "Yes, the Klink App is free to use. You will only be charged if you subscribe for further insights, which are opt-in only. There’s plenty to do in the Klink App free of charge!",
  },
  // {
  //   index: 5,
  //   category: "Learn about Klink",
  //   question: "Will my credit score be impacted?",
  //   answer:
  //     "Klink does not perform a credit check and does not share any information with credit referencing agencies. <br/><br/>Using Klink may in fact <i>improve</i> your credit score by adopting financially responsible behaviours.",
  // },

  // (1) Signing up to Klink
  // {
  //   index: 11,
  //   category: "Signing up to Klink",
  //   question: "When will the Klink App be available to download?",
  //   answer:
  //     "Very soon! We're making the finishing touches now. If you'd like to be first in line, sign up <b><a class='text-magenta' href='https://www.klink-app.com/#signup'>here</a></b> and we'll notify you the moment it's available.",
  // },
  {
    index: 12,
    category: "Signing up to Klink",
    question: "How do I download the Klink App?",
    answer:
      "You can <b><a class='text-magenta' target='_blank' href='https://klink.app.link/download'>download the Klink App</a></b> on the <b><a class='text-magenta' href='https://klink.app.link/download' target='_blank'>Apple App Store</a></b> or on the <b><a class='text-magenta' href='https://klink.app.link/download' target='_blank'>Google Play Store</a></b>",
  },
  {
    index: 13,
    category: "Signing up to Klink",
    question:
      "What devices, operating systems and browsers will be supported by Klink?",
    // question: "What devices, operating systems and browsers are supported by Klink?",
    answer:
      "Klink App is available on iPhone (iOS 13 and higher) and on Android (Android 6.0 and higher). ",
  },
  {
    index: 14,
    category: "Signing up to Klink",
    question: "What countries is Klink available in?",
    answer:
      "Klink serves England, Wales and Scotland, however the app is available internationally in the <b><a class='text-magenta' href='https://klink.app.link/download' target='_blank'>Apple App Store</a></b> or on the <b><a class='text-magenta' href='https://klink.app.link/download' target='_blank'>Google Play Store</a></b>.",
  },
  {
    index: 15,
    category: "Signing up to Klink",
    question: "Why do you ask for my earnings and savings?",
    answer:
      "During the sign-up process, we ask for your earnings and savings as well as information about the home you want to buy. This allows us to build a personalised plan for when you can buy the home you want. We don’t share this information with anyone else.",
  },
  {
    index: 16,
    category: "Signing up to Klink",
    question: "How will you use and store my data?",
    answer:
      "Your information is stored securely according to industry best practices such as encryption in transit and encryption at rest.<br/><br/>We are registered with the Information Commissioner’s Office (Reference: ZB665026). You can find more information about our information security procedures in our <b><a class='text-magenta' href='https://www.klink-app.com/privacy'>Privacy Notice</a></b>.",
  },

  // (2) Linking bank accounts
  {
    index: 201,
    category: "Linking bank accounts",
    question: "Why should I link my bank statements?",
    answer:
      "Linking your bank statements allows the Klink app to give you tailored insights into your spending habits. By securely connecting your accounts, you’ll receive a detailed breakdown of where your money goes each month and see how your spending compares to others in similar situations. This can help you identify areas where you could cut back and save more effectively, all with the goal of helping you build up a deposit and get onto the property ladder. ",
  },
  {
    index: 203,
    category: "Linking bank accounts",
    question: "What is Open Banking?",
    answer:
      "Open Banking is a secure system that allows you to share your bank account information with trusted third-party providers, like Klink, with your consent. It enables us to access your transaction data in a safe, regulated way, providing you with valuable insights into your spending and helping you manage your finances more effectively. With Open Banking, you have full control over what information you share and can disconnect at any time.",
  },
  {
    index: 204,
    category: "Linking bank accounts",
    question: "Which banks do you support?",
    answer:
      "We currently link to the following providers. More will be added over time. <ul><li>Amex</li><li>Bank of Scotland</li><li>Barclaycard</li><li>Barclays</li><li>Capital One</li><li>Chelsea Building Society</li><li>Danske Bank</li><li>First Direct</li><li>Halifax</li><li>HSBC</li><li>Lloyds</li><li>M&S</li><li>MBNA</li><li>Mettle</li><li>Monzo</li><li>Nationwide</li><li>NatWest</li><li>Revolut</li><li>Royal Bank of Scotland</li><li>Santander</li><li>Starling</li><li>Tesco Bank</li><li>Tide</li><li>TSB</li><li>Ulster Bank</li><li>Virgin Money</li><li>Wise</li><li>Yorkshire Building Society</li></ul>",
  },
  {
    index: 205,
    category: "Linking bank accounts",
    question: "Why is my bank not listed?",
    answer:
      "We use Truelayer for our Open Banking connections. Our app connects with most UK banks through Open Banking, but some banks may not yet support Open Banking or haven’t integrated with Truelayer’s platform. We’re continually working to expand our list of supported banks to provide the best experience for our users. If your bank isn’t currently listed, it may be in the process of being added. In the meantime, feel free to reach out to us to let us know which bank you’d like to see supported, and we’ll do our best to make it available soon.",
  },
  {
    index: 206,
    category: "Linking bank accounts",
    question: "Can I link a joint account?",
    answer:
      "Yes absolutely! This will include all transaction data from both account holders as we get no information as to who’s spend is who’s. Connecting all accounts you can allows for the most accurate insights we can provide.",
  },
  {
    index: 207,
    category: "Linking bank accounts",
    question: "What can you see when I link my account?",
    answer:
      "When an account is linked we will securely be provided with: <br/>1. Banking transactions from the account for up to the last 24 months<br/>2. You current account balance<br/>3. Any direct debits and standing orders<br/><br/>Plus other account information such as, account number, sort code and lender.",
  },
  {
    index: 208,
    category: "Linking bank accounts",
    question: "Does Klink store my bank or credit card login credentials?",
    answer:
      "No, Klink does not store your bank or credit card login credentials. When you connect your bank account through Open Banking, the connection is handled securely by an authorised provider. This ensures that your login details are never shared with or stored by Klink or any other third party. We only receive the necessary transaction data to provide insights, and all information is encrypted and protected in line with strict data privacy regulations. Your security is our top priority.",
  },
  {
    index: 209,
    category: "Linking bank accounts",
    question: "How secure is the Klink app?",
    answer:
      "Security is incredibly important to us. We use Open Banking to connect to your accounts. Open Banking was introduced by the UK government to provide a secure way to connect your accounts with third parties without having to share your log-in details with us. Klink uses end-to-end 256-bit TLS encryption as is used by all major banks.",
  },
  {
    index: 210,
    category: "Linking bank accounts",
    question:
      "Can I still use Klink if I don’t have a bank account or am unable to connect my accounts?",
    answer:
      "You can still use the Klink app, you just won’t be able to use the features that rely on your open banking information. This includes but is not limited to; Spending insights, Spendometer and Mortgage Readiness. You will still have access to the Home Goal and Quizzes.",
  },

  // (3) Spending Insights & Spendometer
  {
    index: 301,
    category: "Spending Insights & Spendometer",
    question: "What are spending insights?",
    answer:
      "Spending insights are personalised summaries of your spending habits, based on the data you share through Open Banking. Klink categorises your transactions to highlight where you’re spending the most, comparing your current spend against your average over time. These insights are designed to help you understand your spending patterns better, identify areas where you could save, and ultimately support your journey towards getting onto the property ladder.",
  },
  {
    index: 302,
    category: "Spending Insights & Spendometer",
    question: "How does the Klink spendometer work?",
    answer:
      "The spendometer provides you with a personalised score and rating based on your total spend and spend per category compared against national average spending utilising your open banking data. This allows you to see areas that you may be able reduce spending and save more to get you onto the property ladder faster.",
  },
  {
    index: 303,
    category: "Spending Insights & Spendometer",
    question:
      "My spending isn’t correctly categorised. How can I re-categorise transactions?",
    answer:
      "Currently, you can’t re-categorise transactions through the App. You can let us know if there are incorrect categorisation through the Klink app at Profile > Settings > Help & Support. Alternatively, you can email us at <b><a class='text-magenta' href='mailto:hello@klink-app.com' target='_blank'>hello@klink-app.com</a></b>.<br/>We are busy working on a feature that lets you re-categorise transactions yourself.",
  },

  // (4) Mortgage Readiness Score
  {
    index: 401,
    category: "Mortgage Readiness Score",
    question: "What is the Klink Mortgage Readiness Score?",
    answer:
      "Klink Mortgage Readiness is a feature designed to help you understand how close you are to meeting the financial requirements that mortgage lenders look for. By analysing your Open Banking data, we give you personalised insights into factors that may impact your mortgage eligibility. This includes checking for potential red flags like returned payments, high or increasing debt, affordability concerns, and any high gambling spend. Our goal is to give you a clear picture of your financial readiness, highlighting areas for improvement to help strengthen your chances of getting a mortgage when the time comes.",
  },
  {
    index: 402,
    category: "Mortgage Readiness Score",
    question: "How do I change my goal and financial details?",
    answer:
      "You can change your goal and financial details through the Klink App by going to Profile > Edit Finances and changing the information there.",
  },

  // (5) Quizzes & Rewards
  {
    index: 501,
    category: "Quizzes & Rewards",
    question: "How do Klink rewards work?",
    answer:
      "You can earn Klink coins and diamonds just by opening the app daily, or through various activities such as making purchases, doing quizzes, referring friends, and engaging with our content.<br/><br/>Log into your account and navigate to the Klink rewards section to see your current rewards balance history.<br/><br/>Please go to Klink <b><a class='text-magenta' href='https://www.klink-app.com/prize-competition-terms'>Prize Competition Terms & Conditions</a></b> to learn more.",
  },
  {
    index: 502,
    category: "Quizzes & Rewards",
    question: "How do quizzes work?",
    answer:
      "Our quizzes are designed to be engaging and time-efficient, providing a quick and fun way to test your knowledge. Each quiz consists of 5 multiple choice questions. Simply select the correct answer by clicking on the option.<br/><br/>You have a pre-defined time limit to answer each question. The timer starts as soon as you begin the quiz.<br/>Make sure to read each question carefully and manage your time effectively to answer all questions within the given timeframe.<br/><br/>Once the time limit is reached, your quiz will be automatically submitted, and any unanswered questions will be marked accordingly. If you finish answering all questions before the time runs out, you can manually submit your quiz by clicking the “Submit” button.<br/><br/>After answering each question, you will receive immediate feedback on your performance, including if you answered correctly and after the last question you will be provided your total score for the quiz.",
  },
  {
    index: 503,
    category: "Quizzes & Rewards",
    question: "What do I do if my rewards are missing?",
    answer:
      `If you notice that your Klink coins, diamonds or referrals are missing, follow these steps to resolve the issue:<br/><br/><ul class="pl-10 list-disc"><li><b>Review Recent Transactions: </b>Log into your account and navigate to the Rewards section to review your recent transactions. This will help you confirm if the rewards were earned and recorded correctly.</li><br/><li><b>Allow Processing Time: </b>Sometimes, there may be a slight delay in rewards being credited to your account, especially after recent activities or purchases. Wait for 24-48 hours to see if the coins and diamonds appear.</li><br/><li><b>Contact Customer Support: </b>If your rewards are still missing, contact our customer support team for assistance at <b><a class='text-magenta' href='mailto:hello@klink-app.com' target='_blank'>hello@klink-app.com</a></b>. When contacting support, provide as much information as possible, including your account details, the activity or purchase in question, and the expected number of coins. This will help us investigate and resolve the issue more quickly.</li></ul>`,
  },
  {
    index: 504,
    category: "Quizzes & Rewards",
    question: "What do I get with my rewards?",
    answer:
      "Coins are used to determine your position on the daily leaderboard, diamonds are for weekly, and referrals are for the monthly competition. In each of these competitions you can win more coins or diamonds and win cash. You can also redeem your diamonds for cash payments straight to your bank! Please check the <b><a class='text-magenta' href='https://www.klink-app.com/prize-competition-terms'>Prize Competition Terms & Conditions</a></b> page for more information.",
  },

  // (6) Knowledge & Learning
  {
    index: 601,
    category: "Knowledge & Learning",
    question: "What topics can I learn about in the Klink App?",
    answer:
      "The Klink App includes guides, knowledge nuggets and checklists to help our users improve their financial health, prepare for buying a home and getting ready to qualify for a mortgage.<br/><br/>You can view some of our guides on our <b><a class='text-magenta' href='https://www.klink-app.com/guides'>Guides</a></b> page.",
  },
  {
    index: 602,
    category: "Knowledge & Learning",
    question:
      "I have a question about buying a home that I want to learn more about. Can I request an article?",
    answer:
      "Yes! You can submit an article request by <b><a class='text-magenta' href='mailto:hello@klink-app.com?subject=Article Request' target='_blank'>clicking here</a></b>.",
  },

  // (6) Other FAQs
  {
    index: 701,
    category: "Other FAQs",
    question: "How do I contact the Klink team?",
    answer:
      "You can contact us in app at Profile > Settings > Help & Support. Alternatively, you can email us at <b><a class='text-magenta' href='mailto:hello@klink-app.com' target='_blank'>hello@klink-app.com</a></b>.",
  },
  {
    index: 702,
    category: "Other FAQs",
    question: "Is Klink regulated?",
    answer:
      "Klink App Limited is acting as an agent of TrueLayer, who is providing the regulated Account Information Service, and who is authorised by the Financial Conduct Authority under the Payment Services Regulations 2017 and the Electronic Money Regulations 2011 (Firm Reference Number: 901096).",
  },
  // {
  //   index: 703,
  //   category: "Other FAQs",
  //   question: "How does Klink make money?",
  //   answer:
  //     "Klink offers a subscription service, which you can purchase within the app. We also make money by working with third party partners to offer our customers deals.",
  // },
  {
    index: 704,
    category: "Other FAQs",
    question: "How do I report an issue or a bug?",
    answer:
      "Please send an email to <b><a class='text-magenta' href='mailto:hello@klink-app.com' target='_blank'>hello@klink-app.com</a></b> and include information about the issue or bug. It is also helpful to add a screenshot of the issue.",
  },
  {
    index: 705,
    category: "Other FAQs",
    question: "How do I change my notification settings?",
    answer:
      "You can change your notification settings in the Klink App at Profile > Settings > Notifications.",
  },
  {
    index: 706,
    category: "Other FAQs",
    question: "How do I make a complaint?",
    answer:
      "At Klink, we are committed to providing a service of the very highest standard. We recognise that sometimes things can go wrong, and when they do, we want you to tell us so we can make them right as soon as possible. So if you’re unhappy with something, then please make sure you let us know by emailing us at <b><a class='text-magenta' href='mailto:complaints@klink-app.com' target='_blank'>complaints@klink-app.com</a></b>.<br/><br/>When you contact us, we’ll aim to resolve the issue straight away.<br/><br/>If we’re not sure whether you’d like to raise a formal complaint, we’ll check back with you to make sure we understand fully so we can address your request in the most appropriate way.</br></br>Where we believe we can resolve your complaint within three working days, we will send you our response within that timeframe.</br></br>If the issue is more complex or we can’t resolve the problem within three working days:<br/><ul><li>We’ll send you an email to confirm we’ve received your complaint within that timeframe.</li><li>We’ll always aim to provide a final response to your complaint within 15 calendar days. In exceptional circumstances, if there is a delay beyond 15 days, we’ll keep you posted on our progress explaining the reasons for the delay and the date on which we’ll provide a final response (which will be no later than 35 working days from the date we received your complaint).</li><li>When we provide our final response, we’ll confirm our decision on your complaint, what we’ll do to put things right and information about the Financial Ombudsman Service.</li></ul><br/>If you’re not satisfied with our final response, where you are eligible, you’ll have the right to refer your case to the Financial Ombudsman Service (FOS).<br/><br/>Their address is: Financial Ombudsman Service, Exchange Tower, London, E14 9SR. More information about the service can be found on their website www.financial–ombudsman.org.uk or by calling them on free phone 0800 023 4567 or emailing them at complaint.info@financial-ombudman.org.uk. FOS also provide an online complaint form which is available on their website at https://help.financial-ombudsman.org.uk/help.",
  },
  {
    index: 707,
    category: "Other FAQs",
    question: "If I close or delete my account, what happens to my data?",
    answer:
      "In line with our <b><a class='text-magenta' href='https://www.klink-app.com/privacy'>Privacy Notice</a></b>, you can request to delete your information when you delete your account.",
  },
];

const carouselData: CarouselData = [
  {
    header: "Learn about Klink",
    link: {
      caption: "Learn about Klink",
      href: routes.faqs + "#1",
    },
  },
  {
    header: "Signing up to Klink",
    link: {
      caption: "Signing up to Klink",
      href: routes.faqs + "#2",
    },
  },
  {
    header: "Linking bank accounts",
    link: {
      caption: "Linking bank accounts",
      href: routes.faqs + "#3",
    },
  },
  {
    header: "Spending Insights & Spendometer",
    link: {
      caption: "Spending Insights & Spendometer",
      href: routes.faqs + "#4",
    },
  },
  {
    header: "Mortgage Readiness Score",
    link: {
      caption: "Mortgage Readiness Score",
      href: routes.faqs + "#5",
    },
  },

  {
    header: "Quizzes & Rewards",
    link: {
      caption: "Quizzes & Rewards",
      href: routes.faqs + "#6",
    },
  },
  {
    header: "Knowledge & Learning",
    link: {
      caption: "Knowledge & Learning",
      href: routes.faqs + "#7",
    },
  },
  {
    header: "Other FAQs",
    link: {
      caption: "Other FAQs",
      href: routes.faqs + "#8",
    },
  },
];

export const generateCarouselData = () => {
  return carouselData;
};
